var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-link-to-fill-questionnaire" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "referrals-link-to-fill-questionnaire-modal",
            size: "custom-size",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: {
            show: _vm.onShowModal,
            close: function ($event) {
              _vm.localActive = false
            },
          },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "m-link-to-fill-questionnaire-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: {
                click: function ($event) {
                  _vm.localActive = false
                },
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c("div", { staticClass: "m-link-to-fill-questionnaire-title" }, [
            _vm._v("Ссылка на заполнение анкеты"),
          ]),
          _c("c-input", {
            staticClass: "m-link-to-fill-questionnaire-post",
            attrs: {
              type: "select",
              label: "Должность",
              searchable: true,
              placeholder: "Выберите должность",
              items: _vm.postLocalItems,
            },
            model: {
              value: _vm.postLocalValue,
              callback: function ($$v) {
                _vm.postLocalValue = $$v
              },
              expression: "postLocalValue",
            },
          }),
          _vm.postLocalValue !== null
            ? _c("c-input", {
                staticClass: "m-link-to-fill-questionnaire-link",
                attrs: {
                  editable: false,
                  "copied-to-clipboard": true,
                  type: "text",
                  label: "Ссылка",
                },
                on: { copyToClipboard: _vm.showSuccessMessageCopyClipboard },
                model: {
                  value: _vm.postLocalValue.link,
                  callback: function ($$v) {
                    _vm.$set(_vm.postLocalValue, "link", $$v)
                  },
                  expression: "postLocalValue.link",
                },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "m-link-to-fill-questionnaire-copy-message",
              class: {
                "m-link-to-fill-questionnaire-copy-message-active":
                  _vm.isShowSuccessMessageCopyToClipboard,
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "14",
                    height: "10",
                    viewBox: "0 0 14 10",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z",
                      fill: "#12C971",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z",
                      fill: "#12C971",
                    },
                  }),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "m-link-to-fill-questionnaire-copy-message-text",
                },
                [_vm._v("Ссылка скопирована в буфер обмена")]
              ),
            ]
          ),
          _c("c-button", {
            staticClass: "m-link-to-fill-questionnaire-button-close",
            attrs: { label: "Закрыть" },
            on: { click: _vm.closeModal },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }